import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box, Stack } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";

const TransactionListbyDate = (props) => {
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, dateFormate, ReportViewPermission } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(4);
  const [isError, setIsError] = useState(false);
  const [totalData, setTotalData] = useState({
    amount: 0,
    openbalance: 0,
  });
  const [classicView, setClassicView] = useState(true);

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/transactionlistbydate?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&searchtext=&startdate=${startdate}&enddate=${enddate}&locationid=${localStorage.getItem(
          "Location"
        )}&usertype=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // setResponseData(res.data.ResponseData);
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            OpenBalance: Number(el?.OpenBalance) || 0,
            Amount: Number(el?.Amount) || 0,
          }));
          setResponseData(FilterData);
          setTotalData({
            ...totalData,
            amount: FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.Amount) || 0),
              0
            ),
            openbalance: FilterData.reduce(
              (sum, item) => sum + (parseFloat(item.OpenBalance) || 0),
              0
            ),
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setIsError(true);
        console.log(err);
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  // useEffect(() => {

  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

  //   setLoading(true);

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/transactionlistbydate?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&searchtext=&startdate=${startdate}&enddate=${enddate}&locationid=${localStorage.getItem(
  //         "Location"
  //       )}&usertype=0`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  //   // }
  //   // fetchData();
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  // ]);

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    // setTotalSum(sum);
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      size: "100",
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return moment(Date).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      size: "180",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Bill Payment"
                ? `/receiving-paybills/${row.original.TxnId}`
                : row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.TxnId}`
                : row.original?.TransactionType === "Bill" ||
                  row.original?.TransactionType === "Vendor Credit" ||
                  row.original?.TransactionType === "Purchase Order"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Invoice" ||
                  row.original?.TransactionType === "Return/ Memo"
                ? `/sales-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : row.original?.TransactionType === "Expense"
                ? `/Expense/${row.original.TxnId}`
                : "#";

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: "100",
    },
    {
      header: "Contact",
      accessorKey: "Name",
      // size:"160"
    },
    {
      header: "Memo / Description",
      accessorKey: "MemoDescription",
      size: "120",
    },
    {
      header: "Account",
      accessorKey: "Account",
      // size:"120"
    },
    {
      header: "Split",
      accessorKey: "AccountFullName",
      // size:"110"
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: "120",
      Cell: ({ row }) => {
        const TotalAmount = row?.original?.Amount;
        const TransactionType = row?.original?.TransactionType;

        return (
          <div style={{ textAlign: "end" }}>
            {TransactionType === "Journal Entry"
              ? "-"
              : CurrencySymbols(
                  Number(TotalAmount),
                  { CurrencySymbol },
                  FractionDigits
                )}
          </div>
        );
      },
      // Footer: ({ table }) => {
      //   return (
      //     <Box sx={{ textAlign: "right", fontWeight: "bold", width: "maxContent" }}>
      //       Total: {CurrencySymbols(
      //           Number(totalData.amount).toFixed(FractionDigits),
      //           { CurrencySymbol },
      //           FractionDigits
      //         )}
      //     </Box>
      //   );
      // },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      size: "150",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedUser",
      size: "140",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModifiedDate",
      size: "160",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedUser",
      size: "180",
    },
    {
      header: "Ship Date",
      accessorKey: "ShipDate",
      size: "130",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
      size: "110",
    },
    {
      header: "Customer / Vendor Message",
      accessorKey: "CustomerVendorMessage",
      size: "180",
    },
    {
      header: "Invoice Date",
      accessorKey: "InvoiceDate",
      size: "150",
      Cell: ({ row }) => {
        const InvoiceDate = row?.original?.InvoiceDate;
        if (
          InvoiceDate === "0000-00-00" ||
          InvoiceDate === "" ||
          InvoiceDate === null
        ) {
          return "";
        }
        return moment(InvoiceDate).format(`${dateFormate.toUpperCase()}`);
      },
    },
    {
      header: "Terms",
      accessorKey: "Terms",
      size: "110",
    },
    {
      header: "Ship Via",
      accessorKey: "ShipVia",
      size: "120",
    },
    {
      header: "Tracking",
      accessorKey: "Trackingnumber",
      size: "120",
    },

    {
      header: "PO Status",
      accessorKey: "POStatus",
      size: "130",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: "140",
      Cell: ({ row }) =>
        moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`) ===
        "Invalid date"
          ? ""
          : moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "A/R Paid",
      accessorKey: "ARPaid",
      size: "130",
    },
    {
      header: "A/P Paid",
      size: "130",
      accessorKey: "APPaid",
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: "150",
      Cell: ({ row }) => {
        const OpenBalance = row?.original?.OpenBalance;
        const TransactionType = row?.original?.TransactionType;

        return (
          <div style={{ textAlign: "end" }}>
            {TransactionType === "Journal Entry"
              ? "-"
              : CurrencySymbols(
                  Number(OpenBalance),
                  { CurrencySymbol },
                  FractionDigits
                )}
          </div>
        );
      },
      // Footer: ({ table }) => {
      //   return (
      //     <Box sx={{ textAlign: "right", fontWeight: "bold", width: "maxContent"}}>
      //       Total: {CurrencySymbols(
      //           Number(totalData.openbalance).toFixed(FractionDigits),
      //           { CurrencySymbol },
      //           FractionDigits
      //         )}
      //     </Box>
      //   );
      // },
    },
  ]);
  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  const Classiccolumns = [
    {
      title: "Date",
      field: "Date",
      size: "100",
      headerMenu: headerMenu,
      headerFilter: "input",
      frozen: true,
      defaultVisible: true,
       formatter: (cell) => {
    const rawDate = cell.getValue();
    const formattedDate = moment(rawDate).format(`${dateFormate.toUpperCase()}`);
    return formattedDate === "Invalid date" ? "" : formattedDate;
  },
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      size: "180",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Num",
      field: "Num",
      size: "100",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Contact",
      field: "Name",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Memo / Description",
      field: "MemoDescription",
      size: "120",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Account",
      field: "Account",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Split",
      field: "AccountFullName",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Amount",
      field: "Amount",
      size: "120",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
      defaultVisible: true,
    },
    {
      title: "Created Date",
      field: "CreatedDate",
      size: "150",
      headerMenu: headerMenu,
      headerFilter: "input",
       formatter: (cell) => {
    const rawDate = cell.getValue();
    const formattedDate = moment(rawDate).format(`${dateFormate.toUpperCase()}`);
    return formattedDate === "Invalid date" ? "" : formattedDate;
  },
    },
    {
      title: "Created By",
      field: "CreatedUser",
      size: "140",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "Last Modified",
      field: "LastModifiedDate",
      size: "160",
      headerMenu: headerMenu,
      headerFilter: "input",
       formatter: (cell) => {
    const rawDate = cell.getValue();
    const formattedDate = moment(rawDate).format(`${dateFormate.toUpperCase()}`);
    return formattedDate === "Invalid date" ? "" : formattedDate;
  },
    },
    {
      title: "Last Modified By",
      field: "LastModifiedUser",
      size: "180",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "Ship Date",
      field: "ShipDate",
      size: "130",
      headerMenu: headerMenu,
      headerFilter: "input",
       formatter: (cell) => {
    const rawDate = cell.getValue();
    const formattedDate = moment(rawDate).format(`${dateFormate.toUpperCase()}`);
    return formattedDate === "Invalid date" ? "" : formattedDate;
  },
    },
    {
      title: "Payment Method",
      field: "PaymentMethod",
      size: "110",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Customer / Vendor Message",
      field: "CustomerVendorMessage",
      size: "180",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "Invoice Date",
      field: "InvoiceDate",
      size: "150",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "Terms",
      field: "Terms",
      size: "110",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Ship Via",
      field: "ShipVia",
      size: "120",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "Tracking",
      field: "Trackingnumber",
      size: "120",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "PO Status",
      field: "POStatus",
      size: "130",
      headerMenu: headerMenu,
      headerFilter: "input",
    },
    {
      title: "Due Date",
      field: "DueDate",
      size: "140",
      headerMenu: headerMenu,
      headerFilter: "input",
       formatter: (cell) => {
    const rawDate = cell.getValue();
    const formattedDate = moment(rawDate).format(`${dateFormate.toUpperCase()}`);
    return formattedDate === "Invalid date" ? "" : formattedDate;
  },
    },
    {
      title: "A/R Paid",
      field: "ARPaid",
      size: "130",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
    },
    {
      title: "A/P Paid",
      field: "APPaid",
      size: "130",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
    },
    {
      title: "Open Balance",
      field: "OpenBalance",
      size: "150",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
    },
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Transaction List by Date
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <p className="p">SonarPos</p>
                    <p className="fw-bold p-regular">
                      Transaction List by Date
                    </p>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                      {/* <p>
                      Date: {startdate} - {enddate}
                    </p> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission ? (
                    <p onClick={() => setClassicView(!classicView)}>
                      {" "}
                      {classicView ? "ClassicView" : "Morden View"}
                    </p>
                  ) : (
                    <> </>
                  )}

                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={[]}
                      Reportname={"Sales_By_Category"}
                      frozenRowvalue={0}
                      layout={"fitDataTable"}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Transaction List By Date"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      // enableExpandAll={true}
                      // enableExpanding={true}
                      // expanded={true}
                      columnsVisibility={{
                        CreatedDate: false,
                        CreatedUser: false,
                        LastModifiedDate: false,
                        LastModifiedUser: false,
                        ShipDate: false,
                        PaymentMethod: false,
                        CustomerVendorMessage: false,
                        InvoiceDate: false,
                        Terms: false,
                        ShipVia: false,
                        POStatus: false,
                        DueDate: false,
                        ARPaid: false,
                        APPaid: false,
                        OpenBalance: false,
                        Trackingnumber: false,
                      }}
                      columnGrouping={[]}
                      enableExpandAll={true}
                      enableExpanding={true}
                      // expanded={true}
                      enableRowSelection={false}
                    />
                  )}
                </div>

                {/* <div className="row">
                <div className="col-md-12 text-center">
                  <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6>
                </div>
              </div> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <div style={{ marginTop: "5px" }}>
                    {/* textAlign: "end", */}
                    <>
                      <Stack style={{ fontWeight: "bold" }}>
                        Total Amount:{" "}
                        {CurrencySymbols(
                          Number(totalData.amount).toFixed(FractionDigits),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </Stack>
                      <Stack style={{ fontWeight: "bold" }}>
                        Total Open Balance:{" "}
                        {CurrencySymbols(
                          Number(totalData.openbalance).toFixed(FractionDigits),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </Stack>
                    </>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TransactionListbyDate;
